// Fresh-cut WYSIWYG coral frags. Photos live in /public/corals/.
// Auction start bid + window are owner-configurable here.
export const FRAG_AUCTION = {
  startBid: 30,
  startsLabel: "Sat Aug 22 · 10:00 PM ET",
  endsLabel: "Sun Aug 23 · Midnight ET",
};

// Priced WYSIWYG catalog (from owner's rate cards).
export const FRAG_PRICED = [
  { name: "Medusa Torch", code: "T23", price: 300.0, type: "Torch" },
  { name: "Ultra Acan Lord", code: "WYSIWYG 21", price: 299.99, type: "Acan" },
  { name: "Metallic Trachyphyllia", code: "WYSIWYG 12", price: 250.0, type: "LPS" },
  { name: "Rainbow Branching Hammer", code: "H17", price: 149.99, type: "Hammer" },
  { name: "Pink / Peach Tip Black Torches", code: "T5", price: 149.99, type: "Torch" },
  { name: "Yellow Tipped Octospawn", code: "H9", price: 149.99, type: "Octospawn" },
  { name: "Assorted Light Blue & Orange Yuma Mushroom", code: "", price: 149.99, type: "Mushroom" },
  { name: "Peach Tipped Octospawn", code: "H8", price: 129.99, type: "Octospawn" },
  { name: "Hulk Frogspawn", code: "H5", price: 99.99, type: "Frogspawn" },
  { name: "Bali Green Slimer Acropora", code: "A97", price: 69.99, type: "Acropora" },
  { name: "Montipora Spongodes", code: "A94", price: 59.99, type: "Montipora" },
  { name: "Green Dragon Acropora Echinata", code: "A90", price: 39.99, type: "Acropora" },
];

// Owner's printed price cards were reference-only (not published).

// Fresh-cut frag trays available now.
export const FRAG_GALLERY = [
  { img: "/corals/frag-acans.jpg", title: "Acans & Ultra Acan Lords", note: "Micromussa / Acanthastrea" },
  { img: "/corals/frag-torches.jpg", title: "Torch Corals", note: "Joker · Medusa · Gold Wolverine · Sungod" },
  { img: "/corals/frag-hammer-heads.jpg", title: "Hammer Heads", note: "Aurelia · Holographic · Gold · Frogspawn · Hulk Frogspawn · Peach Octospawn" },
  { img: "/corals/frag-chalice.jpg", title: "Chalices", note: "Miami WWC · Watermelon" },
  { img: "/corals/frag-chalice-hollywood.jpg", title: "Hollywood Stunner Chalice", note: "High-flow chalice frags" },
  { img: "/corals/frag-green-montipora.jpg", title: "Green Montipora", note: "Encrusting / plating monti" },
  { img: "/corals/frag-montipora-spongodes.jpg", title: "Montipora Spongodes", note: "Neon green branching monti" },
];
